// API接口映射
const api = {
  // 理财产品详情
  PRODUCT_LIST_NO: 'FLS01037',
  // 历史收益查询
  // 历史净值查询
  PRODUCT_DETAIL: 'NMB16010',
  PRODUCT_MSG: 'NMB16001',
  PRODUCT_EARNINGS: 'FLS01001',
  //获取理财排行榜及热销
  PRODUCT_HOT: 'FLS06115',
  //理财适合人群
  PRODUCT_CROWD: 'FLS21029',
  // 获取OSB时间
  GET_OSB_TIME: 'FLS01000',
  // 基金信息查询
  FUND_DETAILS: 'NMBFLS02037',
  // 基金购买提示
  FUND_TIPS: 'NMBFLS02038',
  // 基金净值列表
  FUND_NAV_LIST: 'FLS02048',
  // 基金净值图表
  FUND_NAV_CHART: 'FLS21033',
  // 礼品列表查询
  GIFT_INQUIRIES: 'NMB05007',
  // 十分优惠-活动查询
  ACTIVE_INQUIRIES: 'CPM1013T',
  // 大额存单产品目录查询
  CD_PRODUCT_INQUIRIES: 'FLS02089MB',
  // 理财列表查询
  FINANCING_LIST: 'NMBFLS01024',
  // 大额存单列表查询
  LARGE_DEPOSIT_LIST: 'NMBFLS02089',
  // MGM-营销活动列表查询
  MGM_ACTIVITY_LIST: 'NMBFLS03092',
  // MGM-营销活动规则详情查询
  MGM_ACTIVITY_DETAIL: 'NMBFLS03102',
  // MGM-查询推荐人分享信息
  MGM_SHARE_INFO: 'NMBFLS03106',
  // MGM-手机号提交接口(验短信)
  MGM_SHARE_SUBMIT: 'NMBPBS06073',
  // MGM-推送移动展业(非我行客户)
  MGM_SHARE_MIT: 'NMBFLS03107',
  // 发送短信验证码
  GET_MSG: 'NMBNPB01004',
  // 新兴存
  GET_OpenDoorRed: 'NMBFLS02089',
  // 大额存单转让申请登记列表查询免登陆
  TRANSFER_MARKET: 'PSPFLS21021',
  // 资讯查询文章
  INFORMATION: 'OSS01096',
  // 资讯查询产品
  INFORMATION_PRODUCT: 'FLS03132',
  // 微信浏览器内跳转至APP，微信开发标签配置信息
  GET_OpenWeChatToApp: 'PBS06132',
  QUESTIONNAIRE_SEATRCH: 'NMBOSS01112', // 查询问卷
  QUESTIONNAIRE_Upload: 'NMBOSS01118', // 上传问卷
  // 查询历史收益 1401
  QUERYHISTORYPROFIT1401: 'FLS01033',
  // 查询历史收益 1306
  QUERYHISTORYPROFIT1306: 'FLS18002',

  // 因为实时智能接口下架，导致基金曲线问题，所以领导要求把基金详情曲线部分搬过来
  FUND_DETAIL_INFO: 'NMBFLS21080', // 对应手机接口 NMBMPSX3500  获取基金详情
  FUND_MANAGER_INFO: 'NMBFLS21105', // 对应手机接口 NMBMPSX3509  获取基金经理信息 -- 曲线打点用
  FUND_CURRENCY_INFO: 'NMBFLS21109', // 对应手机接口 NMBMPSX3513  非货币型 -- 历史收益率、单位净值、累计净值
  FUND_MONEY_INFO: 'NMBFLS21110', // 对应手机接口 NMBMPSX3514  同花顺基金产品信息列表-货币型基金
  FUND_DEBT_INFO: 'NMBFLS21111', // 对应手机接口 NMBMPSX3515  中债综合/沪深300
  FUND_AVERAGE_INFO: 'NMBFLS03160', // 对应手机接口 NMBMPSX3644  非货币型基金、历史收益率包含本、沪深300、 同类平均
}

/**
 * 安卓下载地址（生产）
 * @type {string}
 */
const androidDownloadUrl =
  'https://a.app.qq.com/o/simple.jsp?pkgname=com.csii&from=singlemessage' // TODO 应用宝地址，暂时弃用
// const androidDownloadUrl = 'http://file.market.xiaomi.com/download/AppStore/09541d77ce17f4731854daf2dd3c78e7a17b6c0ba/com.csii_5.0.29.apk';

/** ########################## 生产环境配置-start ########################## **/
const prod = {
  env: 'prod', // 环境变量
  // BASE_URL: 'https://perbank.ghbank.com.cn/perbank/',     // 生产
  BASE_URL: '/perbank/', // 生产
  // BASE_URL: 'http://183.63.131.115:4001/perbank/',        // sit
  // BASE_URL: 'http://183.63.131.115:4001/perbank/sit/',    // sit
  // BASE_URL: 'http://183.63.131.115:4001/perbank/uat1/',   // uat1
  weChatUrl:
    'https://perbank.ghbank.com.cn/perbank/static/images/integration/financeProShare/',
  // iosShareUrl: 'https://ebank.ghbank.com.cn/public/huaxingclient/HXBankDownload.html',
  iosShareUrl:
    'https://www.ghbank.com.cn/6alsyx/mbdownload/HXBankDownload/HXBankDownload.html',
  api, // API接口映射
  androidDownloadUrl, // 安卓下载地址
  headers: {
    // 报文头
    systemID: 'NMB',
    srcSystemID: 'NMB',
  },
}
/** ########################### 生产环境配置-end ########################### **/

// 开发环境
const dev = {
  env: 'dev',
  BASE_URL: '/perbank/',
  weChatUrl:
    'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/financeProShare/',
  iosShareUrl:
    'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/index.html',
  // http://wbank-test.ghbank.com.cn:4001/perbank/
  api,
  androidDownloadUrl, // 安卓下载地址
  headers: {
    systemID: 'NMB',
    srcSystemID: 'NMB',
  },
}

// sit环境
const sit = {
  env: 'sit',
  BASE_URL: '/perbank/',
  weChatUrl:
    'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/financeProShare/',
  // iosShareUrl: 'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/HXBankDownload/HXBankDownload.html',
  iosShareUrl:
    'https://www.ghbank.com.cn/6alsyx/mbdownload/HXBankDownload/HXBankDownload.html',
  api,
  headers: {
    systemID: 'NMB',
    srcSystemID: 'NMB',
  },
}

// MajorSIT环境
const MajorSIT = {
  env: 'MajorSIT',
  BASE_URL: '/perbank-sit1/',
  weChatUrl:
    'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/financeProShare/',
  // iosShareUrl: 'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/HXBankDownload/HXBankDownload.html',
  iosShareUrl:
    'https://www.ghbank.com.cn/6alsyx/mbdownload/HXBankDownload/HXBankDownload.html',
  api,
  androidDownloadUrl, // 安卓下载地址
  headers: {
    systemID: 'NMB',
    srcSystemID: 'NMB',
  },
}

// MajorSIT2环境
const MajorSIT2 = {
  env: 'MajorSIT2',
  BASE_URL: '/perbank-sit2/',
  weChatUrl:
    'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/financeProShare/',
  // iosShareUrl: 'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/HXBankDownload/HXBankDownload.html',
  iosShareUrl:
    'https://www.ghbank.com.cn/6alsyx/mbdownload/HXBankDownload/HXBankDownload.html',
  api,
  androidDownloadUrl, // 安卓下载地址
  headers: {
    systemID: 'NMB',
    srcSystemID: 'NMB',
  },
}

// MajorUAT1环境
const MajorUAT1 = {
  env: 'MajorUAT1',
  BASE_URL: '/perbank-uat1/',
  weChatUrl:
    'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/financeProShare/',
  // iosShareUrl: 'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/HXBankDownload/HXBankDownload.html',
  iosShareUrl:
    'https://www.ghbank.com.cn/6alsyx/mbdownload/HXBankDownload/HXBankDownload.html',
  api,
  androidDownloadUrl, // 安卓下载地址
  headers: {
    systemID: 'NMB',
    srcSystemID: 'NMB',
  },
}

// MajorUAT2环境
const MajorUAT2 = {
  env: 'MajorUAT2',
  BASE_URL: '/perbank-uat2/',
  weChatUrl:
    'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/financeProShare/',
  // iosShareUrl: 'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/HXBankDownload/HXBankDownload.html',
  iosShareUrl:
    'https://www.ghbank.com.cn/6alsyx/mbdownload/HXBankDownload/HXBankDownload.html',
  api,
  androidDownloadUrl, // 安卓下载地址
  headers: {
    systemID: 'NMB',
    srcSystemID: 'NMB',
  },
}

// uat1环境
const uat1 = {
  env: 'uat1',
  BASE_URL: '/perbank/uat1/',
  weChatUrl:
    'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/financeProShare/',
  iosShareUrl:
    'http://ngwtest.ghbank.com.cn/perbank/static/images/integration/index.html',
  api,
  androidDownloadUrl, // 安卓下载地址
  headers: {
    systemID: 'NMB',
    srcSystemID: 'NMB',
  },
}

export default () => {
  switch (process.env.MGS_WORK_SPACE) {
    case 'env':
      return dev
    case 'SIT':
      return sit
    case 'UAT1':
      return uat1
    case 'MajorSIT':
      return MajorSIT
    case 'MajorSIT2':
      return MajorSIT2
    case 'MajorUAT1':
      return MajorUAT1
    case 'MajorUAT2':
      return MajorUAT2
    case 'production':
      return prod
    case 'prod':
      return prod
    default:
      return prod
  }
}
